import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PATHNAME_TO_MODULE } from '../utils/moduleFromPath';

// Ambient/utility modules enabled for many internal users — they are never a person's
// primary "home", so they don't count when deciding whether someone has a single module.
const UTILITY_MODULES = new Set([
  'rag_search', 'changelog', 'feedback_requests', 'game', 'prode', 'quick_launch', '2fa_codes',
]);

// A plain internal user whose ONLY real (non-utility) module is a single one lands directly
// on that module instead of the Dashboard — e.g. manuel@ardata.com.ar has only live_assist_pro,
// so he goes straight to Live Assist in one click, no "pick the section" step.
// Admins/managers/demo (who see everything) and anyone with more than one real module keep the
// Dashboard as their landing page.
export default function LandingRedirect({ children }) {
  const { isAdmin, isManager, isDemo, hasModule } = useAuth();
  if (isAdmin || isManager || isDemo) return children;

  const realModules = [...new Set(Object.values(PATHNAME_TO_MODULE))]
    .filter((m) => m !== 'dashboard' && !UTILITY_MODULES.has(m))
    .filter((m) => hasModule(m));

  if (realModules.length === 1) {
    const path = Object.keys(PATHNAME_TO_MODULE).find(
      (p) => p !== '/' && PATHNAME_TO_MODULE[p] === realModules[0],
    );
    if (path) return <Navigate to={path} replace />;
  }
  return children;
}
